import i18next from 'i18next';

export const centralApprovalStatus = {
    OPENED: 'O',
    CLOSE: 'F',
    CANCELED: 'A',
    CANCEL_REQUEST: 'D',
    CALENDAR_REQUEST: 'E',
};

export function getCentralApprovalStatusDescription(key) {
    switch (key) {
        case centralApprovalStatus.OPENED:
            return `${i18next.t('approvalCentral:status.opened')}`;
        case centralApprovalStatus.CLOSE:
            return `${i18next.t('approvalCentral:status.closed')}`;
        case centralApprovalStatus.CANCELED:
            return `${i18next.t('approvalCentral:status.canceled')}`;
        case centralApprovalStatus.CANCEL_REQUEST:
            return `${i18next.t('approvalCentral:status.cancelationRequest')}`;
        default:
            return `${i18next.t('approvalCentral:status.closed')}`;
    }
}